import addProductImages from "./addProductImages";
import fetchImages from "./fetchImages";

export default async function initImages(win: WindowProxy) {
  const products: HTMLElement = win.document.querySelectorAll(`.product-tile`);
  const seenCodes = new Set();
  const uniqueProductCodes: Array = [...products]
    .map((product: HTMLElement) => parseFloat(product.dataset.productCode))
    .filter(code => {
      if (seenCodes.has(code)) return false;
      seenCodes.add(code);
      return true;
    });
  const images = await fetchImages(uniqueProductCodes);
  addProductImages(products, images);
}
